import {request_async} from "@/utils/requestAsync";
import { API_URL_EXP_CONSUMER} from "@/model/ConfigModel";

// 设置配置信息
export async function editOfficialWebConfig(info) {
  return request_async(API_URL_EXP_CONSUMER + `/consumer/config/officialWeb`, "post_body", info);
}


